import { render, staticRenderFns } from "./Culturas.vue?vue&type=template&id=2f0c64af&scoped=true&"
import script from "./Culturas.vue?vue&type=script&lang=js&"
export * from "./Culturas.vue?vue&type=script&lang=js&"
import style0 from "./Culturas.vue?vue&type=style&index=0&id=2f0c64af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c64af",
  null
  
)

export default component.exports